import { EMAIL_KIND_CORRECTIONS_APPLIED, type Project } from '@/api/client';
import { ProjectEmailModal } from './ProjectEmailModal';

export type CorrectionsAppliedEmailModalMode = 'status_transition' | 'email_only';

export interface CorrectionsAppliedEmailModalProps {
  open: boolean;
  onClose: () => void;
  project: Project;
  mode: CorrectionsAppliedEmailModalMode;
  intendedState?: string;
}

export function CorrectionsAppliedEmailModal({
  open,
  onClose,
  project,
  mode,
  intendedState,
}: CorrectionsAppliedEmailModalProps) {
  return (
    <ProjectEmailModal
      open={open}
      onClose={onClose}
      project={project}
      emailKind={EMAIL_KIND_CORRECTIONS_APPLIED}
      modalTitle={`Правки внесены: ${project.name ?? 'Проект'}`}
      requireNewState={mode === 'status_transition'}
      newStateWhenSaving={mode === 'status_transition' ? intendedState : undefined}
    />
  );
}
